
import { mapState } from 'vuex'
import { bus } from '~/assets/js/eventBus'
import textTraderTitle from '~/components/textTrader/_title.vue'
export default {
  components: {
    'text-title': textTraderTitle
  },
  inject: ['info'],
  data() {
    const _openAccount = this.info && this.info.openAccount && this.info.openAccount.openAccountInfo ? this.info.openAccount.openAccountInfo : null
    const _count = this.info && this.info.openAccount && this.info.openAccount.accountTypeCount ? this.info.openAccount.accountTypeCount : 0
    return {
      Account: _openAccount,
      count: _count,
      showall: false,
      lineheight: {
        line1: 'auto',
        line2: 'auto',
        line6: 'auto'
      },
      showArrow: false
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile'
    })
  },
  mounted() {
    bus.$on('TextTraderArrow', (sa) => {
      if (sa && (sa.pos == 'kaihu' || sa.pos == 'all') && sa.show) {
        this.showArrow = true
      } else {
        this.showArrow = false
      }
    })
    console.log('开户', this.info.openAccount)
  },
  methods: {
    show(mark) {
      this.showall = mark
      if (mark) {
        this.$nextTick(() => {
          for (let i = 1; i < 13; i++) {
            this.GetLineHeightByClass(`liangdian_tbline${i}`)
          }
        })
      }
    },
    GetLineHeightByClass(cls) {
      const objlist = document.querySelectorAll('.' + cls)
      let hg = 22
      if (objlist && objlist.length > 0) {
        objlist.forEach((item, k) => {
          const height = item.getBoundingClientRect().height
          if (height > hg) {
            hg = height
          }
        })
      }
      objlist.forEach((item) => {
        item.style.height = hg + 'px'
      })
    },
    DealTraderName(content, type) {
      if (!content) {
        return ''
      }
      let ret = content
      if (type == 'text') {
        ret = ret.replace(/\{brokers name}/g, this.info.shortName)
        ret = ret.replace(/\{0}/g, this.info.shortName)
      } else {
        ret = ret.replace('{brokers name}', `<a class="trader" href="${this.getwwwDomain(this.$store.state)}/${this.$store.state.LanguageCode}/dealer/${this.info.traderCode}.html" target="_blank">${this.info.shortName}</a>`)
        ret = ret.replace(/\{brokers name}/g, this.info.shortName)
        ret = ret.replace('{0}', `<a class="trader" href="${this.getwwwDomain(this.$store.state)}/${this.$store.state.LanguageCode}/dealer/${this.info.traderCode}.html" target="_blank">${this.info.shortName}</a>`)
        ret = ret.replace(/\{0}/g, this.info.shortName)
      }
      return ret
    },
    ALB() {
      return this.$store.state.LanguageCode == 'ar' ? 'ALB' : ''
    }
  }
}
